<app-iframe
  *ngIf="source$ | async as url"
  [source]="url"
  (iframeLoad)="viewLoaded($event)"
  (iframeMessage)="messageReceived($event)"
></app-iframe>
